import { InjectionToken } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';

export type FetchAuthSessionFn = typeof fetchAuthSession;

/**
 * Seam over Amplify's session read.
 *
 * `aws-amplify/auth` is an ES module whose exports are non-writable, so a
 * direct module-level import cannot be substituted — which left the
 * force-logout branches of `AuthService` untestable. Routing the one call that
 * governs those branches through a token keeps the production wiring identical
 * (the factory returns the real function) while letting a spec supply its own.
 */
export const FETCH_AUTH_SESSION = new InjectionToken<FetchAuthSessionFn>(
  'FETCH_AUTH_SESSION',
  { providedIn: 'root', factory: () => fetchAuthSession }
);
